import React, { useState, useEffect } from 'react';
import Parse from 'parse';

export default function MachineSelector({ user, onSelect }) {
  const [machines, setMachines] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    const fetchMachines = async () => {
      const Machine = Parse.Object.extend('Machine');
      const query = new Parse.Query(Machine);
      query.equalTo('owner', user); // Only machines owned by the current user
      query.ascending('name');
      const results = await query.find();
      setMachines(results);
    };
    if (user) {
      fetchMachines();
    }
  }, [user]);

  const handleChange = (event) => {
    const selected = machines.find((m) => m.id === event.target.value);
    setSelectedId(event.target.value);
    onSelect(selected);
  };

  return (
    <div style={{ marginTop: 10 }}>
      <select
  className="machine-dropdown"
  value={selectedId || ''}
  onChange={handleChange}
>
        <option value="" disabled>Select your Microdeep...</option>
        {machines.map((machine) => (
          <option key={machine.id} value={machine.id}>
            {machine.get('name')}
          </option>
        ))}
      </select>
    </div>
  );
}